import { ArrowDownOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { destinos } from '../destinos';
import { Demonstracao } from '../components/Demonstracao';

export function Heroi() {
  return (
    <section id="topo" className="heroi">
      <div className="heroi-conteudo">
        <div>
          <a className="heroi-selo" href="#modulos">
            <span /> ENAC E CONCURSOS DE CARTÓRIOS <ArrowRightOutlined />
          </a>
          <h1>
            Potencialize o seu estudo para Cartórios <em>com a Titularis.</em>
          </h1>
        </div>
        <div className="heroi-convite">
          <p className="heroi-descricao">
            Resolva questões do Enac e da 1ª fase dos concursos estaduais, entenda cada
            alternativa e consulte a legislação que fundamenta a resposta. Tudo no mesmo lugar.
          </p>
          <div className="heroi-acoes">
            <Button
              type="primary"
              size="large"
              href={destinos.criarConta}
              icon={<ArrowRightOutlined />}
              iconPlacement="end"
            >
              Criar conta grátis
            </Button>
            <a className="link-demonstracao" href="#demonstracao">
              Experimente abaixo <ArrowDownOutlined />
            </a>
          </div>
          <p className="heroi-microcopy">Sem cartão de crédito. Questões gratuitas toda semana.</p>
        </div>
      </div>
      <Demonstracao />
      <p className="heroi-legenda">Questão 1 do Enac 2025.1 · FGV · Caderno tipo 1</p>
    </section>
  );
}
